import api from './axios';

export interface ManproNotificationItem {
  id: string;
  project_id: string | null;
  user_id: string;
  title: string;
  message: string;
  type: string;
  reference_id: string | null;
  is_read: boolean;
  created_at: string;
  updated_at: string;
  project?: {
    id: string;
    name: string;
  } | null;
}

export interface ManproNotificationResponse {
  response_code: string;
  message: string;
  content: {
    notifications: {
      current_page: number;
      data: ManproNotificationItem[];
      first_page_url: string;
      from: number;
      last_page: number;
      last_page_url: string;
      links: any[];
      next_page_url: string | null;
      path: string;
      per_page: number;
      prev_page_url: string | null;
      to: number;
      total: number;
    };
    unread_count: number;
  };
}

export const getManproNotifications = async (limit = 20, offset = 1): Promise<ManproNotificationResponse> => {
  const { data } = await api.get<ManproNotificationResponse>('/v1/manpro/notifications', {
    params: { limit, offset },
  });
  return data;
};

export const markNotificationAsRead = async (id: string): Promise<any> => {
  const { data } = await api.put(`/v1/manpro/notifications/${id}/read`);
  return data;
};

export const markAllNotificationsAsRead = async (): Promise<any> => {
  const { data } = await api.put('/v1/manpro/notifications/read-all');
  return data;
};

export const deleteNotification = async (id: string): Promise<any> => {
  const { data } = await api.delete(`/v1/manpro/notifications/${id}`);
  return data;
};

export const bulkDeleteNotifications = async (ids: string[]): Promise<any> => {
  const { data } = await api.delete('/v1/manpro/notifications/bulk-delete', {
    data: { ids }
  });
  return data;
};
